/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { ccEnum } from '../Utility/CCEnum';
import NodeTouchActionComponent from '../Utility/Component/Action/NodeTouchActionComponent';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import { CultureID } from './CultureID';
import LocalizationComponent from './LocalizationComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Added to UI components to change the current culture on click. */
@cc._decorator.ccclass
export default class LocalSetterComponent extends NodeTouchActionComponent
{
    /** The [[CultureID]] to change to when clicked. */
    @property({ type: ccEnum.CultureID, visible: true })
    private _culture: CultureID = CultureID.en_us;

    private _localRef: InjectableComponent<LocalizationComponent> = new InjectableComponent();

    protected setContexts(): void
    {
        this._localRef.SetContext(LocalizationComponent);
    }

    /** @hidden */
    protected action = (): void =>
    {
        if (!this._localRef.Value) { return; }
        this._localRef.Value.SetCulture(this._culture);
    }
}
